/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DisabledIntegrationsResponse } from './DisabledIntegrationsResponse';
import {
    DisabledIntegrationsResponseFromJSON,
    DisabledIntegrationsResponseFromJSONTyped,
    DisabledIntegrationsResponseToJSON,
} from './DisabledIntegrationsResponse';

/**
 * 
 * @export
 * @interface FindAllDisabledIntegrations200Response
 */
export interface FindAllDisabledIntegrations200Response {
    /**
     * 
     * @type {DisabledIntegrationsResponse}
     * @memberof FindAllDisabledIntegrations200Response
     */
    data?: DisabledIntegrationsResponse;
}

/**
 * Check if a given object implements the FindAllDisabledIntegrations200Response interface.
 */
export function instanceOfFindAllDisabledIntegrations200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllDisabledIntegrations200ResponseFromJSON(json: any): FindAllDisabledIntegrations200Response {
    return FindAllDisabledIntegrations200ResponseFromJSONTyped(json, false);
}

export function FindAllDisabledIntegrations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllDisabledIntegrations200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DisabledIntegrationsResponseFromJSON(json['data']),
    };
}

export function FindAllDisabledIntegrations200ResponseToJSON(value?: FindAllDisabledIntegrations200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DisabledIntegrationsResponseToJSON(value.data),
    };
}

